<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Say Goodbye to Survival Mode</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctl" id="p0007-01-0"><a id="pagevii">Contents</a></p><a id="pagevii">
</a><p class="cct" id="p0007-02-1"><a id="pagevii"></a><a href="#/chapter3#con1" id="toc1"><i>Introduction: Frazzled, Tired, and Behind? You’re Not Alone </i></a></p>
<p class="cct1" id="p0007-P-1"><a href="#/chapter4#con2" id="toc2">Chapter 1 <span class="cct2">Stop Trying to Do It All</span></a></p>
<p class="cct1" id="p0007-P-2"><span href="#/chapter5#con3" id="toc3" title="Link target outside of Sample">Chapter 2 <span class="cct2">Say Yes to the Best</span></span></p>
<p class="cct1" id="p0007-P-3"><span href="#/chapter6#con4" id="toc4" title="Link target outside of Sample">Chapter 3 <span class="cct2">If You Aim at Nothing, You’ll Hit It Every Time</span></span></p>
<p class="cct1" id="p0007-P-4"><span href="#/chapter7#con5" id="toc5" title="Link target outside of Sample">Chapter 4 <span class="cct2">Discipline Is Not a Bad Word</span></span></p>
<p class="cct1" id="p0007-P-5"><span href="#/chapter8#con6" id="toc6" title="Link target outside of Sample">Chapter 5 <span class="cct2">Be Intentional with Your Bank Account</span></span></p>
<p class="cct1" id="p0007-P-6"><span href="#/chapter9#con7" id="toc7" title="Link target outside of Sample">Chapter 6 <span class="cct2">Manage the Home Front</span></span></p>
<p class="cct1" id="p0007-P-7"><span href="#/chapter10#con8" id="toc8" title="Link target outside of Sample">Chapter 7 <span class="cct2">When You Feel Like a Failure</span></span></p>
<p class="cct1" id="p0007-P-8"><span href="#/chapter11#con9" id="toc9" title="Link target outside of Sample">Chapter 8 <span class="cct2">Yes, You Can Make a Difference</span></span></p>
<p class="cct1" id="p0007-P-9"><span href="#/chapter12#con10" id="toc10" title="Link target outside of Sample">Chapter 9 <span class="cct2">Sometimes It <i>Is</i> About You</span></span></p>
<p class="cct1" id="p0007-P-10"><span href="#/chapter13#con11" id="toc11" title="Link target outside of Sample">Chapter 10 <span class="cct3">Kick-Start Your Success</span><br/><br/></span></p>
<p class="cct1" id="p0007-P-11"><span href="#/chapter14#con12" id="toc12" title="Link target outside of Sample"><i>Appendix </i></span></p>
<p class="cct1" id="p0007-P-12"><span href="#/chapter17#con13" id="toc13" title="Link target outside of Sample"><i>Recommended Resources </i></span></p>
<p class="cct1" id="p0007-P-13"><span href="#/chapter18#con14" id="toc14" title="Link target outside of Sample"><i>Notes </i></span></p>
<p class="cct1" id="p0007-P-14"><span href="#/chapter19#con15" id="toc15" title="Link target outside of Sample"><i>Acknowledgments </i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?1c4a1485